/**
 * NarrowContainer component.
 * @module components/theme/NarrowContainer/NarrowContainer
 */

import React from 'react';

/**
 * Container component.
 * @function NarrowContainer
 * @param {Object} props Component props.
 * @param {React.ReactNode} props.children Child components.
 * @returns {JSX.Element} Markup of the component.
 */
const NarrowContainer = ({ children }) => {
  return <div className='narrowContainer'>{children}</div>;
};

/**
 * Container component.
 * @function Container
 * @param {Object} props Component props.
 * @param {React.ReactNode} props.children Child components.
 * @returns {JSX.Element} Markup of the component.
 */
const Container = ({ children }) => {
  return <div className='normalContainer'>{children}</div>;
};

export { NarrowContainer, Container };
